// extracted by mini-css-extract-plugin
export default {"viewport":"yJ2iJJGAmZE7oUZfVtWP","text":"vi0MWLd9MtQmUnVb6gOC"};